import _ from 'lodash';
import axios from 'axios';
import store from './store';
import router from './router';
import apiBaseUrl from './apiBaseUrl';

const api = axios.create({
  baseURL: apiBaseUrl,
});

const UI_ROUTES_CAN_FAIL = [`/login`, `/forgot-password`, `/init-password`, `/sso`, `/init-account`];
const API_ROUTES_CAN_FAIL = [`/auth/login`, `/auth/refresh`];
const REFRESH_TOKEN_URL = `/auth/refresh`;

api.interceptors.request.use(config => {
  if (!store.state[`ui/mainLayout`].slug) {
    store.dispatch(`ui/mainLayout/loadUrlInfos`);
  }
  const { accessToken } = store.state[`model/auth`];
  const { slug } = store.state[`ui/mainLayout`];
  config.headers[`x-indeego-slug`] = slug;
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
}, error => {
  Promise.reject(error);
});

api.interceptors.response.use(res => res, async error => {
  if (error.response?.data?.code === `INDEEGO_READ_ONLY`) {
    store.commit(`platform/SET_STATE`, { mode: `readOnly` });
    store.dispatch(`platform/refresh`);
    store.dispatch(`showSnackbar`, { color: `warning`, message: `Indeego est en lecture seule. Cette modification est indisponible.` });
  }
  if (!error.response || !error.config) return Promise.reject(error);
  const originalRequest = error.config;
  const route = router.currentRoute.path;
  const initToken = router.currentRoute.query.initToken || null;

  if (originalRequest.url === REFRESH_TOKEN_URL) {
    return Promise.reject(error);
  }

  if (error.response.status === 401 && !originalRequest.isRetrying && !_.includes(API_ROUTES_CAN_FAIL, originalRequest.url)) {
    originalRequest.isRetrying = true;
    const { refreshToken } = store.state[`model/auth`];

    try {
      const res = await api.post(REFRESH_TOKEN_URL, { refreshToken });

      if (`${res.status}`.startsWith(`20`)) {
        const { accessToken, refreshToken } = res.data;
        store.dispatch(`model/auth/saveCredentials`, { accessToken, refreshToken });
        return api(originalRequest);
      }
    } catch (e) {
      store.dispatch(`model/auth/saveCredentials`, {});
      if (_.includes(UI_ROUTES_CAN_FAIL, route)) {
        return Promise.reject(error);
      }
      if (initToken) {
        return router.replace({ name: `initAccount`, query: { token: initToken } });
      }
      return router.replace({ name: `login` });
    }
  }

  return Promise.reject(error);
});

export function ApiError(error) {
  this.error = error;
}

export default api;
